const eventsNavigationNames = {
	navLinkAboutClick: 'left_menu-click-about',
	navTopGridButtonClicked: 'top_menu-click-grid',
	navLeftGridButtonClicked: 'left_menu-click-grid',
	navTopGalleryClicked: 'top_menu-click-gallery',
	navLeftGalleryClicked: 'left_menu-click-gallery',
	navTopChatsButtonClicked: 'top_menu-click-chats',
	navLeftChatsButtonClicked: 'left_menu-click-chats',
	navTopCreateCharacterButtonClicked: 'top_menu-click-create_character',
	navLeftCreateCharacterButtonClicked: 'left_menu-click-create_character',
	navTopCreateImageButtonClicked: 'top_menu-click-create_images',
	navLeftCreateImageButtonClicked: 'left_menu-click-create_images',
	navTopCreateVideoButtonClicked: 'top_menu-click-create_video',
	navLeftCreateVideoButtonClicked: 'left_menu-click-create_video',
	navTopLoginButtonClicked: 'top_menu-click-login',
	navTopSettingsButtonClicked: 'top_menu-click-settings',
	navTopSignOutButtonClicked: 'top_menu-click-sign_out',
	navLeftAffiliateButtonClicked: 'left_menu-click-become_affiliate',
	navLeftPartnershipButtonClicked: 'left_menu-click-creator_partnership',
	navTopMySubscriptionButtonClicked: 'top_menu-click-my_subscription',
};

export default eventsNavigationNames;
